<template>
    <div class="page" :style="{'--styleColor': style.style_color, backgroundImage:'url('+ style.bg_other +')'}">
      <div class="mainBox">
        <div class="typeBox"><i class="iconfont icon-shiwu-shu"></i>全部内容</div>
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
          <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
            <van-cell v-for="(item,index) in list" :key="index" >

                <div class="lessBox" @click="toShow(item.id)">
                   <img class="thumb" :src="item.thumb" alt="">
                   <div class="info">
                      <div class="title">{{item.title}}</div>
                      <div class="status no" v-show="getStatus(item.id)==0"><i class="iconfont icon-dingdan2"></i>未观看</div>
                      <div class="status yes" v-show="getStatus(item.id)==1"><i class="iconfont icon-dingdan2"></i>已观看</div>                      
                      <div class="status ing" v-show="getStatus(item.id)==2"><i class="iconfont icon-dingdan2"></i>观看中</div>
                   </div>
                  </div>

            </van-cell>
          </van-list>
        </van-pull-refresh>
      </div>
      <div class="navBox">
        <div class="navTxt" @click="toHome"><i class="iconfont icon-zhuye"></i>首页</div>
        <div class="navTxt" @click="toMyCenter"><i class="iconfont icon-wode1"></i>个人中心</div>
      </div>
    </div>
</template>

<script>
import {reqLearnList} from '@/api/index2.js'
import zonglan from '@/utils/cp-zonglan.js'
//分享
import { wxShare } from '@/utils/wxshare-wes2.com.js'
import Cookies from 'js-cookie'
export default {
  mixins: [],
  components: {},
  props: {},
  data () {
    return {
      learnid:0,
      token:"",
      list: [],
      currPage:1,
      loading: false,
      finished: false,
      refreshing: false,
      shareImg:"https://img2.hebnews.cn/img/home.53fe0d7.png",
      shareTitle:"",
      shareDesc:"", 
      style:{},
    }
  },
  computed: {},
  watch: {},
  created () {
    this.learnid = this.$route.query.learnid;
    this.token = this.$store.state.token;
    this.shareImg = this.$store.state.actInfo.share_img;
    this.shareTitle = this.$store.state.actInfo.share_title;
    this.shareDesc = this.$store.state.actInfo.share_desc;
    this.style = this.$store.state.actInfo.style;
  },
  mounted() {
    zonglan.pageShare(0,'',this.shareImg,this.shareTitle,this.shareDesc);
  },
  methods: {
    toShow(lessionid){
      this.$router.push({ path: '/show',query:{...this.$route.query,id:lessionid} })
    },
    toHome(){
      this.$router.push({ path: '/index',query:this.$route.query })
    },
    toMyCenter(){
      this.$router.push({ path: '/mycenter',query:this.$route.query })
    },
    onLoad() {
        if (this.refreshing) {
          console.log("刷新");
          this.list = [];
          this.refreshing = false;
          this.currPage = 1;
        }
        this.getList();        
        if (this.list.length >= 40) {
          this.finished = true;
        }
    },
    onRefresh() {
      // 清空列表数据
      this.finished = false;
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.onLoad();
    },
    async getList() {
        let result = await reqLearnList('',{learnid:this.learnid,page:this.currPage});
        if(result.flag=='success') {
          this.list.push(...result.data);
          if(result.currPage==result.totalPage){
            this.finished = true; //全部数据加载完毕
          }else{
            this.currPage = this.currPage + 1;
          }
          this.loading = false; //当前下拉加载完毕
        } else {
          this.$toast({
            icon: 'warning-o',
            message: result.message
          });
        }        
    },
    getStatus(lessid){
      let watchStatus = false;
      let playCookie = Cookies.get('ckplayer-player-cookie');
      if(typeof playCookie == "undefined" || playCookie===null){
        watchStatus = false;
      } else {
        console.log('111');
        watchStatus = playCookie.split(/,|;/).includes('lession_'+lessid);
      }

      let viewed = localStorage.getItem(this.learnid+'_viewed');
      let status = false;
      if(typeof viewed == "undefined" || viewed===null){
        status = false;
      } else {
        console.log('222');
        status = viewed.split(',').includes(lessid);
      }
      
      if(status){
        return 1; //已观看
      } else if (watchStatus) {
        return 2; //正在观看  
      } else {
        return 0; //未观看
      }
    }
  },
  
}
</script>
<style lang="scss" scoped>
.page{
  width: 750px;
  min-height: 1366px;
  font-size: 30px;
  background-repeat: no-repeat;
  background-size: contain;
  .mainBox{
    width: 700px;
    min-height:400px;    
    position: absolute;
    left: 25px;
    top: 200px;    
    background: #fff;
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
    padding-top: 0px;
    padding-bottom: 100px;
    .typeBox{
      width: 660px;
      margin:20px;
      margin-bottom: 0px;
      padding-bottom: 20px;
      padding-top:10px;
      height: 30px;
      line-height: 30px;
      font-size: 30px;
      font-family: "黑体";
      color:#4c4c4c;
      border-bottom: 2px solid #ccc;
      i{
        font-size: 30px; 
        color: #4c4c4c;
        margin-right: 10px;
      }
    }
    .lessBox{
      width: 100%;
      height: auto;
      color:#4c4c4c;
      display: flex;
      justify-content: space-between;
      .thumb{
        width: 256px;
        height: 160px;
        display: block;
        border-radius: 8px;
      }
      .info{
        width: 380px;
        height: auto;
        display: flex;
        flex-wrap: wrap;
        align-content: space-around;
        .title{ 
          width: 100%;
          height: auto;
        }
        .status{
          width: 140px;
          height: 40px;
          line-height: 40px;
          border-radius: 10px;
          text-align: left;
          padding:0px 10px;      
          i{ font-size: 30px; margin-right: 3px;}   
        }
        .no{
          color: #f74434;
        }
        .yes{
          color: #009b21;
        }
        .ing{
          color: orange;
        }
      }
    }
  }
  :deep(.van-cell){ padding:22px;}
  :deep(.van-cell::after){ border-bottom:4px solid #dbdbdb;}
  :deep(.van-pull-refresh){ border-top-left-radius: 0.26667rem; border-top-right-radius: 0.26667rem;}
  .navBox{
    position: fixed;
    left: 0px;
    bottom: 0px;
    width: 750px;
    height: 100px;
    background: #f9f9f9;
    border-top: 1px solid #c8c8c8;
    display: flex;
    justify-content: space-evenly;
    font-size: 30px;
    .navTxt{
      padding:0px 50px;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #808080;
      font-weight: 400;
      i{
        font-size: 40px;
        margin-right: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
        // color:#808080
      }
    }
  }
}
</style>
